import { render, staticRenderFns } from "./ListDeleted.vue?vue&type=template&id=89021910&scoped=true&"
import script from "./ListDeleted.vue?vue&type=script&lang=js&"
export * from "./ListDeleted.vue?vue&type=script&lang=js&"
import style0 from "./ListDeleted.vue?vue&type=style&index=0&id=89021910&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89021910",
  null
  
)

export default component.exports